import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-transfer',
  templateUrl: './stock-transfer.component.html',
  styleUrls: ['./stock-transfer.component.css']
})
export class StockTransferComponent implements OnInit {

  stockInfo = { 
    'sub_item_number': '', 'sub_item_no': '', 'main_item_name': '', 'main_item_name_en': '', 
    'branch_id': '', 'branch_name': '', 'branch_name_en': '', 'store_id': '', 'store_name': '', 
    'store_name_en': '', 'unit_id': '', 'unit_name': '', 'unit_name_en': '',
    'baseline_amount': '', 'available_count': '', 'primary_sub_item_number': '',
    'primary_quantity': '', 'is_expire': '0', 'available_stock': []
  };

  opType = '';
  pageTitle = '';
  // primary_sub_item_number = '';
  // output_qty = 1;
  model = {
    'table_name': 'stock', 'branch_id': '0', 'store_id': '0', 'stock_date_d': new Date(),
    'quantity': '', 'reason': ''
  };
  branchList = [];
  allStoreList = [];
  storeList = [];

  Success_Msg; Error_Msg; Transfer_Stock; Stock_Damage; Stock_Consume;
  To_Branch_Msg; To_Store_Msg; Change_Store_Msg; Quantity_Msg;
  Quantity_0_Msg; Quantity_Less_Msg; Reason_Msg; Number;


  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<StockTransferComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Transfer_Stock').subscribe((res: string) => {
      this.Transfer_Stock = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Stock_Damage').subscribe((res: string) => {
      this.Stock_Damage = res;
    });

    translate.get('Stock_Consume').subscribe((res: string) => {
      this.Stock_Consume = res;
    });

    translate.get('To_Branch_Msg').subscribe((res: string) => {
      this.To_Branch_Msg = res;
    });

    translate.get('To_Store_Msg').subscribe((res: string) => {
      this.To_Store_Msg = res;
    });

    translate.get('Change_Store_Msg').subscribe((res: string) => {
      this.Change_Store_Msg = res;
    });

    translate.get('Quantity_Msg').subscribe((res: string) => {
      this.Quantity_Msg = res;
    });

    translate.get('Quantity_0_Msg').subscribe((res: string) => {
      this.Quantity_0_Msg = res;
    });

    translate.get('Quantity_Less_Msg').subscribe((res: string) => {
      this.Quantity_Less_Msg = res;
    });

    translate.get('Reason_Msg').subscribe((res: string) => {
      this.Reason_Msg = res;
    });

    translate.get('Number').subscribe((res: string) => {
      this.Number = res;
    });
  }


  ngOnInit() {

    if (this.dialog_data != null) {
      this.stockInfo = this.dialog_data[0]['data'];
      this.opType = this.dialog_data[0]['type'];
      console.log(this.stockInfo);

      if (this.opType == 'transfer') {
        this.pageTitle = this.Transfer_Stock;
        let query, obj;

        query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
          " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
          " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            this.branchList = data.data['list'];
            this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'اختر', 'branch_name_en': 'Select' });
          });

        query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE " +
          "`branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "' " +
          "AND `branch_auth`.`status` = '1' AND `branch_auth`.`branch_id` = `store`.`branch_id` AND " +
          "`store`.`status` = '1' AND `branch_auth`.`store_id` = `store`.`store_id`";
    
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.allStoreList = data.data['list'];
          });

        // get cost_per_unit
        // query = "SELECT `cost_per_unit` FROM `stock_base` WHERE `sub_item_number` = '" +
        //   this.stockInfo['primary_sub_item_number'] + "' AND `stock_no` = '" + this.stockInfo['stock_no'] +
        //   "' AND `store_id` = '" + this.stockInfo['store_id'] + "'";
        // obj = { cmd: 'getList', query: query };

        // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        //   .subscribe(data => {
        //     this.applicationConstants.appComp.hideBusyCursor();
        //     this.stockInfo['cost_per_unit'] = data.data['list'][0]['cost_per_unit'];
        //   });
      }
      else {
        if (this.opType == 'damage')
          this.pageTitle = this.Stock_Damage;
        else if (this.opType == 'consume')
          this.pageTitle = this.Stock_Consume;

        if (this.stockInfo['damage_id'] != undefined) {
          this.model['quantity'] = this.stockInfo['damage_quantity'];
          this.model['stock_date_d'] = new Date(this.stockInfo['damage_date']);
          this.model['reason'] = this.stockInfo['reason'];
        }
      }


      // get store nane and branch name
      // query = "SELECT `store`.`store_name`, `store`.`store_name_en`, `branch`.`branch_name`, " + 
      //   "`branch`.`branch_name_en` FROM `store`, `branch` WHERE `store`.`store_id` = '" + this.stockInfo['store_id'] + 
      //   "' AND `store`.`branch_id` = `branch`.`branch_id`";
      // obj = { cmd: 'getList', query: query };
      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      // .subscribe(data => {
      //   this.applicationConstants.appComp.hideBusyCursor();
      //   this.stockInfo['store_name'] = data.data['list'][0]['store_name'];
      //   this.stockInfo['store_name_en'] = data.data['list'][0]['store_name_en'];
      //   this.stockInfo['branch_name'] = data.data['list'][0]['branch_name'];
      //   this.stockInfo['branch_name_en'] = data.data['list'][0]['branch_name_en'];
      // });

      // get unit name
      // query = "SELECT `unit_name`, `unit_name_en` FROM `unit` WHERE `unit_id` = '" + this.stockInfo['unit_id'] + "'";
      // obj = { cmd: 'getList', query: query };
      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      // .subscribe(data => {
      //   this.applicationConstants.appComp.hideBusyCursor();
      //   this.stockInfo['unit_name'] = data.data['list'][0]['unit_name'];
      //   this.stockInfo['unit_name_en'] = data.data['list'][0]['unit_name_en'];
      // });

      // get available quanitity
      // obj = { cmd: 'getAvailableStock', store_id: this.stockInfo['store_id'], 
      //   sub_item_number: this.stockInfo['sub_item_number'], stock_no: this.stockInfo['stock_no'] };

      // this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();
      //     console.log(data);
      //     if (data.status['type'] == 'success') 
      //       this.stockInfo['available_count'] = data.status['msg'][0]['available_count'];
      //     else 
      //       this.stockInfo['available_count'] = '0';
      //   });

      // calculate output quantity
      // let primary_qty = 1;
      // query = "SELECT `sub_item`.`sub_item_number`, `sub_item`.`unit_id`, `unit`.`unit_type`, `unit`.`from_unit`, " + 
      //   "`unit`.`quantity` FROM `sub_item`, `unit` WHERE " + 
      //   "`sub_item`.`main_item_id` = (SELECT `main_item_id` FROM `sub_item` WHERE `sub_item_number` = '" + 
      //   this.stockInfo['sub_item_number'] + "') AND `sub_item`.`status` = '1' AND `sub_item`.`unit_id` = `unit`.`unit_id` ORDER BY `sub_item`.`unit_id`";
      // obj = { cmd: 'getList', query: query };

      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      // .subscribe(data => {
      //   this.applicationConstants.appComp.hideBusyCursor();
      //   let result = data.data['list'];
      //   result.forEach(element => {
      //     if (element.unit_type == 'primary')
      //       this.primary_sub_item_number = element.sub_item_number;
      //     else if (element.unit_type == 'relative')
      //       primary_qty *= Number(element.quantity);

      //     if (element.sub_item_number == this.stockInfo['sub_item_number'])
      //       this.output_qty = primary_qty;
      //   });
      // });

    }
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'اختر', 'store_name_en': 'Select' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });

      // let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      //   " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
      //   " `branch_auth`.`branch_id` = '" + this.model['branch_id'] + "' AND `branch_auth`.`user_id` = '" + 
      //   this.applicationConstants.user_info.user_id + "' AND `branch_auth`.`store_id` = `store`.`store_id`";

      // let obj = { cmd: 'getList', query: query };
      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();
      //     this.storeList = data.data['list'];
      //   });

      // this.allStoreList.forEach(element => {
      //   if (element.branch_id == this.model['branch_id'] && element.store_id != this.stockInfo['store_id'])
      //     this.storeList.push(element);
      // });
    }
  }

  save() {
    if (this.opType == 'transfer') {
      if (this.model['branch_id'] == '0') {
        alert(this.To_Branch_Msg);
        (document.getElementById('branch_id') as HTMLInputElement).focus();
        return false;
      }
      if (this.model['store_id'] == '0') {
        alert(this.To_Store_Msg);
        (document.getElementById('store_id') as HTMLInputElement).focus();
        return false;
      }
      if (this.model['branch_id'] == this.stockInfo['branch_id'] && this.model['store_id'] == this.stockInfo['store_id']) {
        alert(this.Change_Store_Msg);
        (document.getElementById('store_id') as HTMLInputElement).focus();
        return false;
      }
    }

    if (this.model['quantity'] == '') {
      alert(this.Quantity_Msg);
      (document.getElementById('quantity') as HTMLInputElement).focus();
      return false;
    }
    if (Number(this.model['quantity']) == 0) {
      alert(this.Quantity_0_Msg);
      (document.getElementById('quantity') as HTMLInputElement).focus();
      return false;
    }
    if (this.stockInfo['available_count'] != '' && Number(this.model['quantity']) > Number(this.stockInfo['available_count'])) {
      alert(this.Quantity_Less_Msg);
      (document.getElementById('quantity') as HTMLInputElement).focus();
      return false;
    }

    if (this.opType != 'transfer') {
      if (this.model['reason'] == '') {
        alert(this.Reason_Msg);
        (document.getElementById('reason') as HTMLInputElement).focus();
        return false;
      }
    }

    let values = [];
    let obj;
    let stock_date = this.model['stock_date_d'].getFullYear() + "-" +
      (this.model['stock_date_d'].getMonth() + 1) + "-" + this.model['stock_date_d'].getDate() + ' ' +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();

    let available_stock = this.stockInfo['available_stock'];
    let counter = Number(this.model['quantity']);
    let query;

    if (this.opType == 'transfer') {

      // get stock no
      query = "SELECT COALESCE(MAX(`stock_no`), 0) AS 'stock_no' FROM `stock` WHERE `sub_item_number` = '" +
        this.stockInfo['primary_sub_item_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let stock_no = Number(data.data['list'][0]['stock_no']) + 1;
          // this.model['stock_no'] = String(Number(data.data['list'][0]['stock_no']) + 1);

          available_stock.forEach(element => {
            if (counter > 0 && Number(element.available_count) > 0) {
    
              if (Number(element.available_count) >= counter) {
                values.push({
                  'table_name': this.model['table_name'], 'stock_id': '0', 'stock_no': stock_no,
                  'store_id': this.model['store_id'], 'sub_item_number': this.stockInfo['primary_sub_item_number'],
                  'stock_date': stock_date, 
                  'quantity': (counter * Number(element.primary_qty)).toFixed(2),
                  'transfer_from': this.stockInfo['store_id'], 'from_stock': element.stock_no,
                  'invoice_no': element.invoice_no, 'production_no': element.production_no,
                  'from_sub_item_number': this.stockInfo['sub_item_number'], 'from_quantity': counter,
                  'comment': 'transferred from store ' + this.stockInfo['store_id']
                });
          
                values.push({
                  'table_name': 'stock_base', 'baseline_id': '0',
                  'sub_item_number': this.stockInfo['primary_sub_item_number'], 'stock_no': stock_no,
                  'store_id': this.model['store_id'], 'base_date': stock_date,
                  'baseline_amount': (counter * Number(element.primary_qty)).toFixed(2),
                  'cost_per_unit': element.cost_per_unit, 'is_manual': '2', 
                  'source': 'stock_transfer', 'invoice_no': element.invoice_no,
                  'production_no': element.production_no
                });
          
                if (element.expiry_date != null) {
                  values[values.length - 2]['expiry_date'] = element.expiry_date;
                  values[values.length - 1]['expiry_date'] = element.expiry_date;
                }
                counter = 0;
              }
              else {
                values.push({
                  'table_name': this.model['table_name'], 'stock_id': '0', 'stock_no': stock_no,
                  'store_id': this.model['store_id'], 'sub_item_number': this.stockInfo['primary_sub_item_number'],
                  'stock_date': stock_date, 
                  'quantity': (Number(element.available_count) * Number(element.primary_qty)).toFixed(2),
                  'transfer_from': this.stockInfo['store_id'], 'from_stock': element.stock_no,
                  'invoice_no': element.invoice_no, 'production_no': element.production_no,
                  'from_sub_item_number': this.stockInfo['sub_item_number'], 'from_quantity': element.available_count,
                  'comment': 'transferred from store ' + this.stockInfo['store_id']
                });
          
                values.push({
                  'table_name': 'stock_base', 'baseline_id': '0',
                  'sub_item_number': this.stockInfo['primary_sub_item_number'], 'stock_no': stock_no,
                  'store_id': this.model['store_id'], 'base_date': stock_date,
                  'baseline_amount': (Number(element.available_count) * Number(element.primary_qty)).toFixed(2),
                  'cost_per_unit': element.cost_per_unit, 'is_manual': '2', 'source': 'stock_transfer', 
                  'invoice_no': element.invoice_no, 'production_no': element.production_no,
                });
          
                if (element.expiry_date != null) {
                  values[values.length - 2]['expiry_date'] = element.expiry_date;
                  values[values.length - 1]['expiry_date'] = element.expiry_date;
                }
                counter -= Number(element.available_count);
              }
              stock_no += 1;
            }
          });
    
          obj = { cmd: 'add', values: values };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              if (data.status['type'] == 'success') {
                alert(this.Success_Msg);
                this.dialog_data = { 'op_type': 'success' };
                this.dialogRef.close(this.dialog_data);
              }
              else {
                alert(this.Error_Msg);
              }
            });
        });
      
    } 
    else {
      let year = this.model['stock_date_d'].getFullYear();

      available_stock.forEach(element => {
        if (counter > 0 && Number(element.available_count) > 0) {

          if (Number(element.available_count) >= counter) {
            values.push({
              'table_name': 'stock_damage', 'damage_id': '0', 'no':'0', 'year': year, 
              'damage_no': '', 'stock_no': element.stock_no,
              'store_id': this.stockInfo['store_id'], 'sub_item_number': this.stockInfo['primary_sub_item_number'],
              'damage_date': stock_date, 'damage_type': this.opType, 'key': 'damage_id', 'flag': 'new',
              'quantity': (counter * Number(element.primary_qty)).toFixed(2),
              'reason': this.model['reason'], 'from_sub_item_number': this.stockInfo['sub_item_number'], 
              'from_quantity': counter
            });
            counter = 0;
          }
          else {
            values.push({
              'table_name': 'stock_damage', 'damage_id': '0', 'no':'0', 'year': year, 
              'damage_no': '', 'stock_no': element.stock_no,
              'store_id': this.stockInfo['store_id'], 'sub_item_number': this.stockInfo['primary_sub_item_number'],
              'damage_date': stock_date, 'damage_type': this.opType, 'key': 'damage_id', 'flag': 'new',
              'quantity': (Number(element.available_count) * Number(element.primary_qty)).toFixed(2),
              'reason': this.model['reason'], 'from_sub_item_number': this.stockInfo['sub_item_number'], 
              'from_quantity': element.available_count
            });
            counter -= Number(element.available_count);
          }
        }
      });
      
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + "-" + year + "-";
      let idWhere = " WHERE `year` = '" + year + "' AND `store_id` = '" + this.stockInfo['store_id'] + "'";

      obj = { cmd: 'add', values: values, pk: 'damage_no', id: 'no', main_table: 'stock_damage', 
            prefix: prefix, idWhere: idWhere };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg + ', ' + this.Number + ': ' + data.status['msg'][0]['number']);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });

      // get damage id
      // query = "SELECT COALESCE(MAX(`damage_id`), 0) AS 'damage_id' FROM `stock_damage`";
      // obj = { cmd: 'getList', query: query };

      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();
      //     let damage_id = Number(data.data['list'][0]['damage_id']) + 1;
      //     let damage_no = '';
      //   });

      // if (this.stockInfo['damage_id'] == undefined) {
        // let prefix = this.applicationConstants.user_branch_info.user_branch_id + "-";
        // obj = { cmd: 'add', values: values, pk: 'damage_no', id: 'damage_id', main_table: 'stock_damage', prefix: prefix };
      // }
      // else 
      //   obj = { cmd: 'updateAdv', values: values };
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
